import {utilHelper} from "../../_helpers";

const relativeUrl = 'api/appRequestLog'

export const appRequestLogService = {
    getItem,
    search,
    searchDashboard,
    depurate
};

function getItem(id) {
    return utilHelper.doRequest(`${relativeUrl}/${id}`, 'GET')
}

function search(offset, max, data) {
    return utilHelper.doRequest(`${relativeUrl}/search?max=${max}&offset=${offset}`, 'POST', data)
}

function depurate( data ) {
    return utilHelper.doRequest(`${relativeUrl}/depurate`, 'POST', data)
}

function searchDashboard(data) {
    return utilHelper.doRequest(`${relativeUrl}/searchDashboard`, 'POST', data)
}